import { render, staticRenderFns } from "./TcoinBalance.vue?vue&type=template&id=d37eb68c&scoped=true&"
import script from "./TcoinBalance.vue?vue&type=script&lang=ts&"
export * from "./TcoinBalance.vue?vue&type=script&lang=ts&"
import style0 from "./TcoinBalance.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TcoinBalance.vue?vue&type=style&index=1&id=d37eb68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37eb68c",
  null
  
)

export default component.exports